import React, { useState } from "react";
import {
  Button,
  Empty,
  List,
  Tabs,
  Typography,
  Popover,
  Checkbox,
  Select,
  message,
  Input,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import axios from "../../axios";
import { HANDLE_ON_CHANGE } from "../../redux/CommonInitialsate";
const { Option } = Select;

function PokerestimatePopup({ item, apicall, type, closepopover, closemodal }) {
  const { employeeList } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [checkboxOptions, setCheckboxOptions] = useState([1, 2, 3, 5]);
  const [selectedOptions, setSelectedOptions] = useState([]); // Selected checkboxes
  const [fibNumbers, setFibNumbers] = useState([1, 2, 3, 5]);
  const [selectedTeamMembers, setSelectedTeamMembers] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [showInput, setShowInput] = useState(false);
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };
  const handleAddOption = () => {
    if (inputValue && !isNaN(inputValue)) {
      const newOption = parseInt(inputValue);
      if (!checkboxOptions.includes(newOption)) {
        setCheckboxOptions([...checkboxOptions, newOption]);
        setInputValue(""); // Clear the input after adding
        setShowInput(false); // Hide the input field
      }
    }
  };
  const handleCheckboxChange = (checkedValues) => {
    setSelectedOptions(checkedValues);
  };
  const handleTeamMemberChange = (value) => {
    setSelectedTeamMembers(value);
  };
  const removeLastFibonacciOption = () => {
    if (checkboxOptions?.length > 2) {
      setCheckboxOptions(checkboxOptions?.slice(0, -1)); // Remove the last option
      setFibNumbers(fibNumbers?.slice(0, -1)); // Update Fibonacci sequence
    }
  };
  const handleConfirm = (item) => {
    if (selectedOptions?.length === 0) {
      message.warning("Please select at least one option."); // Validation for options
      return;
    }

    if (selectedTeamMembers?.length === 0) {
      message.warning("Please select at least one team member."); // Validation for team members
      return;
    }

    // console.log("Selected Options:", selectedOptions);
    // console.log("Selected Team Members:", selectedTeamMembers);
    if (selectedTeamMembers?.length > 0 && selectedOptions?.length > 0) {
      // console.log(item);
      const selectedTeamMembersDetails = selectedTeamMembers?.map((id) => {
        const member = employeeList?.find((m) => m.teammemberid === id);
        return {
          UserId: member?.teammemberid,
          Username: member?.firstname + " " + member?.lastname,
          Estimate: null,
          UpdatedAt: null,
          IsEstimated: null,
        };
      });
      let patchdata = {
        ScrummastergivenOption: selectedOptions,
        TeamMembers: selectedTeamMembersDetails,
        AverageEstimation: null,
      };

      let data = {
        CurrentStage: [
          {
            StageCode: "RFD",
            StageName: "Refined",
            DateMoved: moment().format("YYYY-MM-DD"),
          },
        ],
        PokerEstimation: patchdata,
        IsPokerEst: "Y",
      };
      axios
        .patch(`agilesaas_issue_details?IssueId=eq.${item.IssueId}`, data)
        .then(async (res) => {
          // console.log(res);
          setSelectedOptions([]);
          setSelectedTeamMembers([]);
          closepopover(null);
          await message.success("Story updated for poker estimation");
          closemodal();
          dispatch(HANDLE_ON_CHANGE({ name: "Refresh", value: true }));
        })
        .catch((err) => {
          console.log(err);
          message.error("Story updated for poker estimation failed");
          closepopover(null);
          setSelectedOptions([]);
          setSelectedTeamMembers([]);
        });
    }
  };
  return (
    <div>
      <div className="mt-3 d-flex">
        Select man days one or more options for estimate
        <Button
          size="small"
          onClick={removeLastFibonacciOption}
          style={{ marginLeft: "8px" }}
          disabled={checkboxOptions.length <= 2} // Disable "-" button when only 2 options remain
        >
          -
        </Button>
        <Button
          size="small"
          style={{ marginLeft: "8px" }}
          onClick={() => setShowInput(true)}
        >
          +
        </Button>
      </div>
      <div
        className="pt-1"
        style={{
          display: "flex",
          flexWrap: "wrap",
          maxWidth:
            "260px" /* Adjust the max-width to control how many items per row */,
          gap: "10px",
        }}
      >
        <Checkbox.Group
          options={checkboxOptions?.map((value) => ({
            label: value,
            value: value,
          }))}
          value={selectedOptions}
          onChange={handleCheckboxChange}
        />
        {showInput && (
          <div style={{ marginTop: "10px" }} className="">
            <Input
              placeholder="Enter a number"
              value={inputValue}
              onChange={handleInputChange}
              style={{ width: "120px", marginRight: "10px" }}
            />
            <Button size="small" type="primary" ghost onClick={handleAddOption}>
              Add{" "}
            </Button>
            {"  "}
            <Button
              size="small"
              danger
              onClick={() => {
                setShowInput(false);
                setInputValue("");
              }}
            >
              Close
            </Button>
          </div>
        )}
      </div>

      <div className="mt-2 pt-1">
        Select team members who needs to estimate
        <Select
          mode="multiple"
          style={{ width: "100%" }}
          placeholder="Select team members"
          onChange={handleTeamMemberChange}
          value={selectedTeamMembers}
          allowClear
          filterOption={
            (input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 // Custom filtering logic
          }
          getPopupContainer={(triggerNode) => triggerNode.parentNode}
        >
          {employeeList?.map((member) => (
            <Option key={member.teammemberid} value={member.teammemberid}>
              {member.firstname}
            </Option>
          ))}
        </Select>
      </div>
      <div className="mt-2 pt-1 d-flex justify-content-end">
        <Button type="primary" ghost onClick={() => handleConfirm(item)}>
          Submit
        </Button>
      </div>
    </div>
  );
}

export default PokerestimatePopup;
